import React from 'react';
import { Box, Text, Anchor } from 'grommet';
import { Facebook, Twitter } from 'grommet-icons';
import { Row } from 'components/atoms';

const Footer = () => {
  return (
    <Box
      tag="footer"
      background={'footerBackgroundColor'}
      pad={'small'}
      elevation={'medium'}
      flex={false}
    >
      <Box direction={'row'} justify={'between'} fill>
        <Box>
          <Box direction={'row'} gap={'small'} justify={'start'}>
            <Anchor
              style={{ textTransform: 'uppercase' }}
              weight={'500'}
              size={'xsmall'}
              rel="noopener noreferrer"
              href={'https://www.betterbankingoptions.com/privacy-policy'}
              label={'Privacy Policy'}
              color={'footerLinkColor'}
            />
            <Anchor
              style={{ textTransform: 'uppercase' }}
              weight={'500'}
              size={'xsmall'}
              rel="noopener noreferrer"
              href={'https://www.betterbankingoptions.com/terms-conditions'}
              label={'Terms & Conditions'}
              color={'footerLinkColor'}
            />
          </Box>
        </Box>
        <Row gap={'small'} justify={'center'} align={'center'}>
          <Anchor
            size={'xsmall'}
            rel="noopener noreferrer"
            href={'https://www.facebook.com/betterbankingoptions'}
            target={'_blank'}
            color={'footerLinkColor'}
          >
            <Facebook color={'footerLinkColor'} size={'20px'} />
          </Anchor>
          <Anchor
            size={'xsmall'}
            rel="noopener noreferrer"
            href={'https://twitter.com/BB_Options'}
            target={'_blank'}
            color={'footerLinkColor'}
          >
            <Twitter color={'footerLinkColor'} size={'20px'} />
          </Anchor>
        </Row>
        <Text size={'xsmall'} color={'footerTextColor'}>
          Copyright {new Date().getFullYear()} Just Money Advisors
        </Text>
      </Box>
    </Box>
  );
};

export default Footer;
